import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
import { EMAIL_STATISTICS_API } from '../../../mailing/email-statistics/api/email-statistics-api';
import { RemovalConditionsInterface } from '../types/removal-conditions-interface';
export function useRemovalConditions() {
  const $ = _c(8);
  const {
    user,
    isWorkspaceOwner,
    isWsAdmin
  } = useUser();
  const canManageRemovalConditions = isWorkspaceOwner || isWsAdmin;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== canManageRemovalConditions || $[2] !== user) {
    t1 = () => {
      if (user && canManageRemovalConditions) {
        return `${EMAIL_STATISTICS_API}/contact/removal-conditions/list`;
      }
      return null;
    };
    $[1] = canManageRemovalConditions;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: removalConditions,
    mutate
  } = useSWR(t1, fetcher);
  let t2;
  if ($[4] !== canManageRemovalConditions || $[5] !== mutate || $[6] !== removalConditions) {
    t2 = {
      removalConditions,
      mutate,
      canManageRemovalConditions
    };
    $[4] = canManageRemovalConditions;
    $[5] = mutate;
    $[6] = removalConditions;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}